import React from "react";
import { SunsetSplashPanel } from "../../../components/panels/SplashPanel/SunsetSplashPanel";
import { ISplashPanelProps, OriginalSplashPanel } from "../../../components/panels/SplashPanel/OriginalSplashPanel";
import { ICTA } from "../../../types/ICTA";
import { ISplashPanelVariants } from "../../../types/common";
import { BoxButtonsSplashPanel } from "../../../components/panels/SplashPanel/BoxButtonsSplashPanel";
import { HorizontalBoxButtonsSplashPanel } from "../../../components/panels/SplashPanel/HorizontalBoxButtonsSplashPanel";
import { ListOfArticlesSplashPanel } from "../../../components/panels/SplashPanel/ListOfArticlesSplashPanel";
import { ArticleSearchSplashPanel } from "../../../components/panels/SplashPanel/ArticleSearchSplashPanel";
import { RateWatchPanel } from "../../../components/panels/RateWatch";
import { ImportantInfoPanel } from "../../../components/panels/SplashPanel/importantInfoPanel";
import { WhatWeOfferPanel } from "../../../components/panels/SplashPanel/WhatWeOfferPanel";

export type GetSplashPanelProps = ISplashPanelProps & {
  id: string;
  callToActions: ICTA[];
  variant?: ISplashPanelVariants;
};

export const getSplashPanel = ({
  id,
  title,
  alignment,
  backgroundColour,
  mainContent,
  callToActions,
  disclaimer,
  image,
  imageBorderRadius,
  youTubeVideoId,
  hubSpotPortalId,
  hubSpotFormId,
  saasquatchTenantAlias,
  saasquatchWidgetType,
  headerAnchor,
  headingType,
  mediaAlignment,
  mediaWidth,
  lookerId,
  infogramId,
  variant,
  tickCrossList,
  preset,
  betterV2,
  snapScroll,
}: GetSplashPanelProps) => {
  let SplashPanel;
  switch (variant) {
    case ISplashPanelVariants.SUNSET:
      SplashPanel = SunsetSplashPanel;
      break;
    case ISplashPanelVariants.BOX_BUTTONS:
      SplashPanel = BoxButtonsSplashPanel;
      break;
    case ISplashPanelVariants.HORIZONTAL_BOX_BUTTONS:
      SplashPanel = HorizontalBoxButtonsSplashPanel;
      break;
    case ISplashPanelVariants.LIST_OF_ARTICLES:
      SplashPanel = ListOfArticlesSplashPanel;
      break;
    case ISplashPanelVariants.ARTICLE_SEARCH:
      SplashPanel = ArticleSearchSplashPanel;
      break;
    case ISplashPanelVariants.RATE_WATCH:
      SplashPanel = RateWatchPanel;
      break;
    case ISplashPanelVariants.IMPORTANT_INFO:
      SplashPanel = ImportantInfoPanel;
      break;
    case ISplashPanelVariants.WHAT_WE_OFFER:
      SplashPanel = WhatWeOfferPanel;
      break;
    case ISplashPanelVariants.ORIGINAL:
    default:
      SplashPanel = OriginalSplashPanel;
      break;
  }
  return (
    <SplashPanel
      index={id}
      key={id}
      title={title}
      alignment={alignment}
      backgroundColour={backgroundColour}
      mainContent={mainContent}
      ctas={callToActions}
      disclaimer={disclaimer}
      image={image}
      imageBorderRadius={imageBorderRadius}
      lookerId={lookerId}
      youTubeVideoId={youTubeVideoId}
      hubSpotPortalId={hubSpotPortalId}
      hubSpotFormId={hubSpotFormId}
      saasquatchTenantAlias={saasquatchTenantAlias}
      saasquatchWidgetType={saasquatchWidgetType}
      infogramId={infogramId}
      mediaAlignment={mediaAlignment}
      headingType={headingType}
      mediaWidth={mediaWidth}
      headerAnchor={headerAnchor}
      tickCrossList={tickCrossList}
      preset={preset}
      betterV2={betterV2}
      snapScroll={snapScroll}
    />
  );
};
